<div class="grid">
  <div class="col-12 pb-0">
    <div class="card title-card flex px-0 pb-0">
      <div class="flex flex-column">
        <div class="flex flex-column sm:flex-row px-3 mb-2">
          <i class="pi pi-cog title-card-icon"></i>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.hwCatalog' | transloco}}</p>
            <p>{{'menu.descriptions.hwCatalog' | transloco}}</p>
          </div>
        </div>
        <div *ngIf="this.items">
          <p-tabMenu
            #tab
            [model]="items"
            [activeItem]="activeItem"
            (click)="activateMenu(tab)"
            class="hidden xl:inline"
          ></p-tabMenu>
          <p-tabMenu
            #tabIcon
            [model]="items"
            [activeItem]="activeItem"
            (click)="activateMenu(tabIcon)"
            class="xl:hidden"
          >
            <ng-template pTemplate="item" let-item let-i="index">
              <i [className]="item.icon"></i>
            </ng-template>
          </p-tabMenu>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12" *ngIf="this.items">
    <app-default-devices *ngIf="activeItem.id == 'devices'"></app-default-devices>
    <app-default-asset-representations *ngIf="activeItem.id == 'asset-representations'"></app-default-asset-representations>
    <app-default-device-categories *ngIf="activeItem.id == 'device-categories'"></app-default-device-categories>
    <app-default-measurement-types *ngIf="activeItem.id == 'measurement-types'"></app-default-measurement-types>
    <app-default-property-types *ngIf="activeItem.id == 'property-types'"></app-default-property-types>
    <app-default-decoders *ngIf="activeItem.id == 'decoders'"></app-default-decoders>
    <app-default-encoders *ngIf="activeItem.id == 'encoders'"></app-default-encoders>
  </div>
</div>
